export default __webpack_public_path__ + "static/media/audiences-to-activate.png";